<mg-card
  paddingX="4"
  paddingY="4">
  <div
    fxLayout="column"
    fxLayoutAlign="start stretch"
    fxLayoutGap="12px">
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center">
      <mg-text variant="header-md-secondary">
        {{ bellScheduleEnabledForCurrentUser ? MESSAGES.SCHEDULE_TITLE_FOR_BELL : MESSAGES.SCHEDULE_TITLE }}
      </mg-text>
      <mg-btn
        id="schedule-widget-click-view-all"
        variant="outlined"
        size="small"
        (pressed)="handleViewAllPressed()">
        {{
          bellScheduleEnabledForCurrentUser ? MESSAGES.SCHEDULE_BUTTON_LABEL_FOR_BELL : MESSAGES.SCHEDULE_BUTTON_LABEL
        }}
      </mg-btn>
    </div>

    <div class="tw-flex tw-flex-column tw-gap-2">
      <button
        *ngIf="showHomeroom"
        class="schedule btn-reset"
        fxLayout="row"
        fxLayoutAlign="space-between center"
        (click)="handleHomeroomPressed()">
        <div>
          <div class="tw-flex tw-items-center tw-gap-1">
            <mg-icon
              class="schedule-icon"
              iconName="mg-homeroom">
            </mg-icon>
            <mg-text
              variant="header-sm"
              [numberOfLines]="1">
              {{ MESSAGES.SCHEDULE_HOMEROOM }}
            </mg-text>
          </div>
        </div>
        <mg-icon
          class="chevron-icon"
          iconName="mg-chevron-right">
        </mg-icon>
      </button>
      <ng-container *ngIf="scheduleItems.length > 0; else emptyStateTemplate">
        <button
          *ngFor="let schedule of scheduleItems"
          [title]="schedule.name"
          class="schedule btn-reset"
          fxLayout="row"
          fxLayoutAlign="space-between center"
          (click)="handleScheduleItemPressed(schedule)">
          <div>
            <div class="tw-flex tw-items-center tw-gap-1">
              <mg-icon
                class="schedule-icon"
                [iconName]="schedule.type === SectionType.FLEX ? 'mg-flextime-menu-o' : 'mg-schedule'">
              </mg-icon>
              <mg-text
                variant="header-sm"
                matTooltipClass="mg-tooltip"
                [matTooltip]="schedule.name"
                [numberOfLines]="1"
                spacing="0-half">
                {{ schedule.name }}
              </mg-text>
            </div>
            <div class="row-2">
              <mg-text
                variant="body-sm"
                [numberOfLines]="1">
                {{ schedule.period }}
              </mg-text>
            </div>
            <div class="tw-flex tw-items-center tw-gap-4">
              <div
                *ngIf="schedule.startTime && schedule.endTime"
                class="tw-flex tw-items-center tw-gap-0.5">
                <mg-icon
                  class="small-icon"
                  iconName="mg-time-hollow">
                </mg-icon>
                <mg-text
                  variant="body-sm"
                  [numberOfLines]="1">
                  {{ $any(schedule) | formatTimeRange }}
                </mg-text>
              </div>
              <div
                *ngIf="schedule.location"
                class="tw-flex tw-items-center tw-gap-0.5">
                <mg-icon
                  class="small-icon"
                  iconName="mg-location-on">
                </mg-icon>
                <mg-text
                  variant="body-sm"
                  [numberOfLines]="1">
                  {{ schedule.location }}
                </mg-text>
              </div>
            </div>
          </div>
          <mg-icon
            class="chevron-icon"
            iconName="mg-chevron-right">
          </mg-icon>
        </button>
      </ng-container>

      <ng-template #emptyStateTemplate>
        <mg-empty-state
          [title]="MESSAGES.EMPTY_SCHEDULE_TITLE"
          [subtitle]="MESSAGES.EMPTY_SCHEDULE_DESC">
        </mg-empty-state>
      </ng-template>
    </div>
  </div>
</mg-card>
